module.exports = __webpack_public_path__ + "static/img/admin_main_log.92e1ffda.svg";